import { IconProps } from "./";
import Icon from "./assets/settings_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Settings(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
